/**
 * FunctionMaturityView - Diagram-centric function maturity view
 *
 * Displays a large architecture diagram that changes based on maturity level.
 * The diagram is central - level selection is compact tabs at the top.
 *
 * Uses DiagramCentricView for the main visualization.
 */

import React from 'react';
import { HelpCircle } from 'lucide-react';
import { CISA_FUNCTIONS, CISA_PILLARS } from '../../../config/cisaMaturityModel';
import DiagramCentricView from './DiagramCentricView';
import './DiagramCentricView.css';

/**
 * FunctionMaturityView Component
 *
 * Now diagram-first instead of card-first.
 * The architecture diagram is the hero, with compact level tabs.
 */
function FunctionMaturityView({
  functionCode,
  pillarCode,
  currentLevel = 'TRADITIONAL',
  targetLevel,
  onViewLevel,
  onStartAssessment,
  onViewGapAnalysis,
  onSetCurrentLevel,
  onSetTargetLevel
}) {
  const pillar = CISA_PILLARS.find(p => p.code === pillarCode);
  const functions = CISA_FUNCTIONS[pillarCode] || [];
  const fn = functions.find(f => f.code === functionCode);

  if (!fn) {
    return (
      <div className="ztj-empty-state">
        <HelpCircle size={48} />
        <p>Function not found</p>
      </div>
    );
  }

  return (
    <DiagramCentricView
      functionCode={functionCode}
      functionName={fn.name}
      pillarCode={pillarCode}
      currentLevel={currentLevel}
      targetLevel={targetLevel}
      onSetCurrentLevel={onSetCurrentLevel}
      onSetTargetLevel={onSetTargetLevel}
      onStartAssessment={() => onStartAssessment?.('CURRENT')}
    />
  );
}

export default FunctionMaturityView;
